import http from './api'

const route = 'app/controlepreco/'

export default {
  showGraficoPrecoPraticadoGeral: (dataInicial, dataFinal, empresaSelect, produtos, vendedores, redes, tokencontrato, areas, segmento) => {
    return http.post(route + 'showGraficoPrecoPraticadoGeral', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresaSelect,
      produtos: produtos,
      vendedores: vendedores,
      redes: redes,
      tokenContrato: tokencontrato,
      areas: areas,
      segmento: segmento,
    })
  },

  showDadosTabelaPrecoPraticadoGeral: (preco, dataInicial, dataFinal, empresaSelect, produtos, vendedores, redes, tokencontrato, areas, segmento) => {
    return http.post(route + 'showDadosTabelaPrecoPraticadoGeral', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      preco: preco,
      empresas: empresaSelect,
      produtos: produtos,
      vendedores: vendedores,
      redes: redes,
      tokenContrato: tokencontrato,
      areas: areas,
      segmento: segmento,
    })
  },

  showGraficoPrecoPraticadoCidade: (dataInicial, dataFinal, empresaSelect, produtos, vendedores, redes, cidades, areas, tokencontrato, segmento) => {
    return http.post(route + 'showGraficoPrecoPraticadoCidade', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresaSelect,
      produtos: produtos,
      vendedores: vendedores,
      redes: redes,
      cidades: cidades,
      areas: areas,
      tokenContrato: tokencontrato,
      segmento: segmento,
    })
  },

  showDadosTabelaPrecoPraticadoCidade: (preco, dataInicial, dataFinal, empresaSelect, produtos, vendedores, redes, cidades, areas, tokencontrato, segmento) => {
    return http.post(route + 'showDadosTabelaPrecoPraticadoCidade', {
      preco: preco,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresaSelect,
      produtos: produtos,
      vendedores: vendedores,
      redes: redes,
      cidades: cidades,
      areas: areas,
      tokenContrato: tokencontrato,
      segmento: segmento,
    })
  },
}
